import React from "react"
import styled from "styled-components"
import CloseButton from "../../ui/components/close-button/close-button.component"
import Newsletter from "./newsletter.component"
import useTranslationHook from "../../hooks/use-translation.hook"

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: auto;
  margin-top: 5%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  max-width: 960px;
  width: 100%;
  box-shadow: 0 2px 20px 0 rgba(59, 63, 66, 0.15);
  padding: 24px;
  position: relative;
  @media (max-width: 900px) {
    flex-direction: column-reverse;
    max-width: 95vw;
    width: unset;
    margin-left: 10px;
    margin-right: 10px;
  }
`

const ImageSection = styled.div`
  flex: 1 1 50%;
  min-width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 900px) {
    width: 100%;
    min-height: 180px;
    min-width: unset;
  }
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
  }
`

const ContentSection = styled.div`
  flex: 1 1 50%;
  padding: 0 24px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  @media (max-width: 900px) {
    padding: 24px 12px 16px 12px;
  }
`

const Title = styled.h2`
  font-family: Facto;
  font-size: 23px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  margin-bottom: 0;

  span {
    color: #804c2f;
  }

  @media (max-width: 900px) {
    text-align: center;
  }
`

const ThankYouTitle = styled(Title)`
  text-align: center;
`

const Subtitle = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-weight: 500;
  margin-top: 18px;
  margin-bottom: 18px;
  text-align: center;
`

const CloseBtn = styled(CloseButton)`
  position: absolute;
  top: 32px;
  right: 32px;
  z-index: 2;

  border-radius: 8px;
`

const Legal = styled.div`
  color: #222;
  margin-top: 18px;
  line-height: 1.7;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;

  a {
    color: #6aa8b3;
    text-decoration: underline;
  }

  @media (max-width: 900px) {
    text-align: center;
  }
`

type Props = {
  onClose: () => void
  isNewsletterSigningFinished?: boolean
  setIsNewsletterSigningFinished?: () => void
}

const NewsletterModalContent: React.FC<Props> = ({
  onClose,
  isNewsletterSigningFinished,
  setIsNewsletterSigningFinished,
}) => {
  const { translate } = useTranslationHook()
  return (
    <ModalWrapper>
      <ContentSection>
        {!isNewsletterSigningFinished ? (
          <>
            <Title
              dangerouslySetInnerHTML={{ __html: translate("newslsetter-one") }}
            />
            <Newsletter
              split={false}
              buttonText={translate("newsletter-subscribe")}
              className="newsletter-modal-form"
              type="modal"
              onSuccess={() =>
                setIsNewsletterSigningFinished &&
                setIsNewsletterSigningFinished()
              }
            />
            <Legal>
              {translate("newsletter-two")}{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translate("Privacy Policy")}
              </a>{" "}
              {translate("newsletter-three")}{" "}
              <a
                href="/newsletter-terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translate("newsletter-terms")}
              </a>
              .
            </Legal>
          </>
        ) : (
          <>
            <ThankYouTitle>{translate("newsletter-thanks")}</ThankYouTitle>
            <Subtitle>{translate("newsletter-thanks-subtitle")}</Subtitle>
          </>
        )}
      </ContentSection>
      <ImageSection>
        <CloseBtn onClick={onClose} />
        <img src="/img/newsletter_img.jpg" alt="Newsletter" />
      </ImageSection>
    </ModalWrapper>
  )
}

export default NewsletterModalContent
